<template>
  <div
    class="text-center max-w-500"
  >
    <LottiePlayer
      :height="150"
      :width="150"
      :animation-data="animationData"
    />
    <div class="text-2xl font-semibold font-heading my-20">
      Please, Try Again
    </div>
    <p class="text-base text-gray-350">
      We cannot process your loan without securely connecting to Plaid.
    </p>
    <PlaidSecurityInfo />
    <AppButton
      class="mx-auto mt-40"
      @click="handleClick"
    >
      Re-launch Plaid
    </AppButton>
  </div>
</template>

<script>
import LottiePlayer from '@/components/common/lottie/LottiePlayer.vue'
import AppButton from '@/components/common/buttons/AppButton'
import PlaidSecurityInfo from './PlaidSecurityInfo.vue'
import DataLayer from '@/utilities/data-layer'

export default {
  name: 'PlaidEducation',

  components: {
    LottiePlayer,
    AppButton,
    PlaidSecurityInfo
  },

  data () {
    return {
      animationData: require('@/assets/lottie/plaid/warning-icon.json')
    }
  },

  mounted () {
    DataLayer.pushObject({
      event: 'spring_plaid_relaunch_screen'
    })
  },

  methods: {
    handleClick () {
      DataLayer.pushObject({
        event: 'spring_plaid_relaunch_plaid_button_click'
      })
      this.$emit('relaunch-plaid')
    }
  }

}
</script>
